import { lazy } from 'react'

export const PlanPace = lazy(() => import('./PlanPace'))
